import {
  parseSearchArrayValue,
  parseSearchBooleanValue,
  parseSearchNumberValue,
  parseSearchStringValue,
} from 'infrastructure/functions/parse-query-string';
import { Assignee } from 'infrastructure/enums';
import { useQueryFilterNew } from 'infrastructure/hooks/common/use-query-param-new';
import { endOfDay, startOfMonth } from 'date-fns';

import type { TParseFunctions } from 'infrastructure/hooks/common/use-query-param-new';
import type { TDashboardActivityFilter } from './use-get-dashboard-activity';

export const defaultValues: TDashboardActivityFilter = {
  page: 1,
  assignee: Assignee.Free,
  applySpecialFilter: true,
  reviewed: false,
  reverse: false,
  startTime: startOfMonth(new Date()).getTime(),
  endTime: endOfDay(new Date()).getTime(),
};

const parseFunctions: TParseFunctions<TDashboardActivityFilter> = {
  page: parseSearchNumberValue,
  reviewed: parseSearchBooleanValue,
  reverse: parseSearchBooleanValue,
  readingType: parseSearchStringValue,
  clinicState: parseSearchStringValue,
  doctorGuid: parseSearchArrayValue,
  patientGuid: parseSearchStringValue,
  clinicGuid: parseSearchStringValue,
  startTime: parseSearchNumberValue,
  endTime: parseSearchNumberValue,
  assignee: parseSearchStringValue,
  status: parseSearchStringValue,
  slaReadings: parseSearchStringValue,
  insuranceType: parseSearchStringValue,
  actionTimesQuota: parseSearchStringValue,
  name: parseSearchStringValue,
  childClinic: parseSearchBooleanValue,
  croStatus: parseSearchArrayValue,
  parentClinicOption: parseSearchStringValue,
};

export const useActivityFilter = () => {
  const { count, filter, resetFilter, updateFilter } =
    useQueryFilterNew<TDashboardActivityFilter>(defaultValues, parseFunctions, [
      'page',
    ]);

  return {
    count,
    filter,
    resetFilter,
    updateQueryParams: updateFilter,
  };
};
